import { HomeContainer } from './HomeContainer';

const name = 'HomeContainer';

export { name, HomeContainer };
